// src/application/hooks/useAddCompany.js
import { useEffect, useState } from 'react';
import { ApiUserRepository } from '../../infrastructure/repositories/ApiUserRepository';
import { SaveUser } from '../UseCase/SaveUser';
import useApiClient from '../../infrastructure/apiClient';
import { AuditLogRepository } from '../../domain/repositories/AuditLogRepository';
import { GetAuditLogs } from '../UseCase/GetAuditLogs';
import { ApiAuditLogRepository } from '../../infrastructure/repositories/ApiAuditLogRepository';

export const useGetAuditLog = () => {
  const [auditLogs, setAuditLogs] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const apiClient = useApiClient();


  const getAuditLogs = async (auditLogRequest,operation,userName) => {
    debugger;
    try {
      console.log('I am in getAuditLogUseCase hook');   
      setIsLoading(true);
      setError(null);  
      const auditLogRepository = new ApiAuditLogRepository(apiClient);
      const getAuditLogUseCase = new GetAuditLogs(auditLogRepository);

      auditLogRequest = {
        ...auditLogRequest,
        operation,
        userName
      };
      const result = await getAuditLogUseCase.execute(auditLogRequest);
      if(result.status === 200){
      setAuditLogs(result.data);
      }
      else
        setAuditLogs([]);
    } catch (err) {
      setError(err.message);
    }
    finally{
      setIsLoading(false);
    }
  };

  return { getAuditLogs, auditLogs, error, isLoading };
};
export default useGetAuditLog;
